import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { parkingCharacteristicsManual, } from 'constants/parkingCharacteristics'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
  },
  options: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  label: {
    width: 200
  },
}));

const Characteristics = props => {
  const { className, parkingInfos, handleFieldChange, ...rest } = props;

  const classes = useStyles();

  return parkingInfos && (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Characteristics" />
      <CardContent>
        <div className={classes.options}>
          {parkingCharacteristicsManual.map((characteristic, index) => (
            <FormControlLabel
              key={characteristic.id}
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  checked={parkingInfos.characteristics.includes(characteristic.id)}
                  onChange={(event) => { handleFieldChange(event, 'characteristics', Number(event.target.value)) }} value={characteristic.id}
                />
              }
              label={characteristic.name}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

Characteristics.propTypes = {
  parkingInfos: PropTypes.object,
  handleFieldChange: PropTypes.func,
  className: PropTypes.string,
};

export default Characteristics;
